// Content of the live sales demo («Modo demo» in Settings, Bronze's own client only): for each kind
// of restaurant the presenter can pick, three orders pending their photo. EDIT HERE ONLY — products,
// order numbers, platforms and which item the first analysis reports as missing. Everything is
// fictitious and brand-free: no real order, no real customer, no third-party brand.
//
// `labelKey` is the i18n key of the category's name (src/i18n-messages.js); product names are data
// and stay in Spanish, like a Spanish restaurant's ticket.
// `items` uses OrderItem's shape minus the ids (added when the order is built):
//   { icon: ':shortcode:', quantity, name, group, items?: [sub-items] }
// `group` is the product's detection category (Pizzas, Bebidas, Salsas...): the ticket's grouped view
// lists the products by it, menus broken into their pieces, as a real ticket does with `group_name`.
// A menu line has no group of its own; each of its pieces has one.
// `firstMissing` is what the FIRST analysis of that order says is missing, in the raw
// /item-comparison shape (_buildAnalysisResult maps it into the real «Falta X» popup): `group_name`
// is the missing product's `group`, `total_quantity` that group's units in the order.
// Every later analysis of the same order comes back correct.

// Ticket group of a product with no `group` (none in this catalog: a fallback, never a bucket).
export const looseGroupName = 'Complementos';

export const DEFAULT_CATEGORY = 'burger';

export const categories = [
    {
        id: 'pizza',
        labelKey: 'message.demoCategoryPizza',
        icon: ':pizza:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100517284',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':pizza:',
                        quantity: 1,
                        name: 'Menú Pizza Mediana',
                        items: [
                            { icon: ':pizza:', quantity: 1, name: 'Pizza Barbacoa mediana', group: 'Pizzas' },
                            { icon: ':bread:', quantity: 1, name: 'Pan de ajo', group: 'Entrantes' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de cola 50 cl', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':poultry_leg:', quantity: 1, name: 'Alitas de pollo 6 uds', group: 'Pollo' },
                ],
                firstMissing: {
                    group_name: 'Pollo',
                    icon: 'chicken',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Alitas de pollo 6 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'C4M8R',
                createdMinAgo: 4,
                items: [
                    { icon: ':pizza:', quantity: 2, name: 'Pizza Margarita familiar', group: 'Pizzas' },
                    { icon: ':bread:', quantity: 1, name: 'Palitos de queso 8 uds', group: 'Entrantes' },
                    { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de naranja 1,5 L', group: 'Bebidas' },
                ],
                firstMissing: {
                    group_name: 'Bebidas',
                    icon: 'cup_with_straw',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Refresco de naranja 1,5 L'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '61427',
                createdMinAgo: 6,
                items: [
                    { icon: ':pizza:', quantity: 1, name: 'Pizza Cuatro Quesos mediana', group: 'Pizzas' },
                    { icon: ':pizza:', quantity: 1, name: 'Pizza Pepperoni mediana', group: 'Pizzas' },
                    { icon: ':ice_cream:', quantity: 1, name: 'Helado de vainilla 500 ml', group: 'Postres' },
                ],
                firstMissing: {
                    group_name: 'Postres',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Helado de vainilla 500 ml'],
                },
            },
        ],
    },
    {
        id: 'burger',
        labelKey: 'message.demoCategoryBurger',
        icon: ':hamburger:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100482913',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':hamburger:',
                        quantity: 1,
                        name: 'Menú Hamburguesa Clásica',
                        items: [
                            { icon: ':hamburger:', quantity: 1, name: 'Hamburguesa Clásica', group: 'Hamburguesas' },
                            { icon: ':french_fries:', quantity: 1, name: 'Patatas medianas', group: 'Patatas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de cola mediano', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':poultry_leg:', quantity: 1, name: 'Nuggets de pollo 6 uds', group: 'Pollo' },
                    { icon: ':bowl_with_spoon:', quantity: 1, name: 'Salsa barbacoa', group: 'Salsas' },
                ],
                firstMissing: {
                    group_name: 'Pollo',
                    icon: 'chicken',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Nuggets de pollo 6 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'B7K2Q',
                createdMinAgo: 4,
                items: [
                    {
                        icon: ':hamburger:',
                        quantity: 1,
                        name: 'Menú Pollo Crujiente',
                        items: [
                            { icon: ':hamburger:', quantity: 1, name: 'Hamburguesa de pollo crujiente', group: 'Hamburguesas' },
                            { icon: ':french_fries:', quantity: 1, name: 'Patatas gajo medianas', group: 'Patatas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de naranja mediano', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':onion:', quantity: 1, name: 'Aros de cebolla 8 uds', group: 'Entrantes' },
                ],
                firstMissing: {
                    group_name: 'Bebidas',
                    icon: 'cup_with_straw',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Refresco de naranja mediano'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '58213',
                createdMinAgo: 6,
                items: [
                    {
                        icon: ':hamburger:',
                        quantity: 2,
                        name: 'Menú Doble Queso',
                        items: [
                            { icon: ':hamburger:', quantity: 2, name: 'Hamburguesa doble con queso', group: 'Hamburguesas' },
                            { icon: ':french_fries:', quantity: 2, name: 'Patatas medianas', group: 'Patatas' },
                            { icon: ':cup_with_straw:', quantity: 2, name: 'Refresco de cola zero mediano', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':ice_cream:', quantity: 1, name: 'Sundae de chocolate', group: 'Postres' },
                ],
                firstMissing: {
                    group_name: 'Postres',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Sundae de chocolate'],
                },
            },
        ],
    },
    {
        id: 'chicken',
        labelKey: 'message.demoCategoryChicken',
        icon: ':poultry_leg:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100533871',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':poultry_leg:',
                        quantity: 1,
                        name: 'Cubo 8 piezas',
                        items: [
                            { icon: ':poultry_leg:', quantity: 8, name: 'Pieza de pollo frito', group: 'Pollo' },
                            { icon: ':french_fries:', quantity: 2, name: 'Patatas grandes', group: 'Patatas' },
                            { icon: ':cup_with_straw:', quantity: 2, name: 'Refresco de cola grande', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':green_salad:', quantity: 1, name: 'Ensalada de col', group: 'Ensaladas' },
                ],
                firstMissing: {
                    group_name: 'Ensaladas',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Ensalada de col'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'D9P3W',
                createdMinAgo: 4,
                items: [
                    {
                        icon: ':poultry_leg:',
                        quantity: 1,
                        name: 'Menú Tiras Crujientes',
                        items: [
                            { icon: ':poultry_leg:', quantity: 5, name: 'Tiras de pollo crujiente', group: 'Pollo' },
                            { icon: ':french_fries:', quantity: 1, name: 'Patatas medianas', group: 'Patatas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Té helado mediano', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':bowl_with_spoon:', quantity: 2, name: 'Salsa miel y mostaza', group: 'Salsas' },
                ],
                firstMissing: {
                    group_name: 'Salsas',
                    icon: 'sauce',
                    missing_quantity: 1,
                    total_quantity: 2,
                    name: ['Salsa miel y mostaza'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '63390',
                createdMinAgo: 6,
                items: [
                    { icon: ':poultry_leg:', quantity: 1, name: 'Alitas picantes 9 uds', group: 'Pollo' },
                    { icon: ':poultry_leg:', quantity: 1, name: 'Palomitas de pollo grandes', group: 'Pollo' },
                    { icon: ':french_fries:', quantity: 1, name: 'Patatas grandes', group: 'Patatas' },
                ],
                firstMissing: {
                    group_name: 'Patatas',
                    icon: 'french_fries',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Patatas grandes'],
                },
            },
        ],
    },
    {
        id: 'sushi',
        labelKey: 'message.demoCategorySushi',
        icon: ':sushi:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100548126',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':sushi:',
                        quantity: 1,
                        name: 'Combo 24 piezas',
                        items: [
                            { icon: ':sushi:', quantity: 8, name: 'California roll', group: 'Sushi' },
                            { icon: ':sushi:', quantity: 8, name: 'Maki de salmón', group: 'Sushi' },
                            { icon: ':sushi:', quantity: 8, name: 'Nigiri variado', group: 'Sushi' },
                        ],
                    },
                    { icon: ':dumpling:', quantity: 1, name: 'Gyozas de pollo 6 uds', group: 'Gyozas' },
                    { icon: ':bowl_with_spoon:', quantity: 2, name: 'Salsa de soja', group: 'Salsas' },
                ],
                firstMissing: {
                    group_name: 'Gyozas',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Gyozas de pollo 6 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'F2T6H',
                createdMinAgo: 4,
                items: [
                    { icon: ':bento:', quantity: 1, name: 'Poke de salmón', group: 'Poke' },
                    { icon: ':green_salad:', quantity: 1, name: 'Edamame', group: 'Entrantes' },
                    { icon: ':green_salad:', quantity: 1, name: 'Ensalada wakame', group: 'Entrantes' },
                ],
                firstMissing: {
                    group_name: 'Entrantes',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 2,
                    name: ['Ensalada wakame'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '67752',
                createdMinAgo: 6,
                items: [
                    { icon: ':sushi:', quantity: 1, name: 'Uramaki de atún picante 8 uds', group: 'Sushi' },
                    { icon: ':fried_shrimp:', quantity: 1, name: 'Tempura de langostinos 5 uds', group: 'Tempura' },
                    { icon: ':cake:', quantity: 1, name: 'Mochi de té verde 2 uds', group: 'Postres' },
                ],
                firstMissing: {
                    group_name: 'Postres',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Mochi de té verde 2 uds'],
                },
            },
        ],
    },
    {
        id: 'noodles',
        labelKey: 'message.demoCategoryNoodles',
        icon: ':ramen:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100561937',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':ramen:',
                        quantity: 1,
                        name: 'Menú Ramen',
                        items: [
                            { icon: ':ramen:', quantity: 1, name: 'Ramen de cerdo', group: 'Ramen' },
                            { icon: ':dumpling:', quantity: 1, name: 'Gyozas de cerdo 5 uds', group: 'Gyozas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Té helado de limón', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':fried_shrimp:', quantity: 1, name: 'Rollitos de primavera 4 uds', group: 'Entrantes' },
                    { icon: ':bowl_with_spoon:', quantity: 1, name: 'Salsa agridulce', group: 'Salsas' },
                ],
                firstMissing: {
                    group_name: 'Entrantes',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Rollitos de primavera 4 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'N5V8J',
                createdMinAgo: 4,
                items: [
                    { icon: ':spaghetti:', quantity: 1, name: 'Pad thai de langostinos', group: 'Noodles' },
                    { icon: ':spaghetti:', quantity: 1, name: 'Yakisoba de pollo', group: 'Noodles' },
                    { icon: ':cup_with_straw:', quantity: 2, name: 'Refresco de lima 33 cl', group: 'Bebidas' },
                ],
                firstMissing: {
                    group_name: 'Bebidas',
                    icon: 'cup_with_straw',
                    missing_quantity: 1,
                    total_quantity: 2,
                    name: ['Refresco de lima 33 cl'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '71836',
                createdMinAgo: 6,
                items: [
                    { icon: ':spaghetti:', quantity: 1, name: 'Udon salteado con verduras', group: 'Noodles' },
                    { icon: ':dumpling:', quantity: 1, name: 'Gyozas de verduras 5 uds', group: 'Gyozas' },
                    { icon: ':custard:', quantity: 1, name: 'Flan de coco', group: 'Postres' },
                ],
                firstMissing: {
                    group_name: 'Postres',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Flan de coco'],
                },
            },
        ],
    },
    {
        id: 'tacos',
        labelKey: 'message.demoCategoryTacos',
        icon: ':taco:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100574208',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':taco:',
                        quantity: 1,
                        name: 'Menú Tacos al Pastor',
                        items: [
                            { icon: ':taco:', quantity: 3, name: 'Tacos al pastor', group: 'Tacos' },
                            { icon: ':corn:', quantity: 1, name: 'Nachos con queso', group: 'Nachos' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Agua de horchata', group: 'Bebidas' },
                        ],
                    },
                    { icon: ':avocado:', quantity: 1, name: 'Guacamole', group: 'Salsas' },
                ],
                firstMissing: {
                    group_name: 'Salsas',
                    icon: 'sauce',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Guacamole'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'T3X7L',
                createdMinAgo: 4,
                items: [
                    { icon: ':burrito:', quantity: 2, name: 'Burrito de pollo', group: 'Burritos' },
                    { icon: ':stuffed_flatbread:', quantity: 1, name: 'Quesadilla de queso', group: 'Quesadillas' },
                    { icon: ':tropical_drink:', quantity: 1, name: 'Limonada con menta', group: 'Bebidas' },
                ],
                firstMissing: {
                    group_name: 'Bebidas',
                    icon: 'cup_with_straw',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Limonada con menta'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '74209',
                createdMinAgo: 6,
                items: [
                    { icon: ':taco:', quantity: 3, name: 'Tacos de carnitas', group: 'Tacos' },
                    { icon: ':corn:', quantity: 1, name: 'Nachos con carne', group: 'Nachos' },
                    { icon: ':doughnut:', quantity: 1, name: 'Churros con chocolate', group: 'Postres' },
                ],
                firstMissing: {
                    group_name: 'Postres',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Churros con chocolate'],
                },
            },
        ],
    },
];

export function categoryById(id) {
    return categories.find((category) => category.id === id) || categories.find((c) => c.id === DEFAULT_CATEGORY);
}
